module.exports = "/assets/site/images/camp_placeholder.jpg?c5871506c44e48091e3bca6002c5a553";